import { render, staticRenderFns } from "./EditNomRegistru.vue?vue&type=template&id=a027e884&scoped=true&"
import script from "./EditNomRegistru.ts?vue&type=script&lang=ts&"
export * from "./EditNomRegistru.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a027e884",
  null
  
)

export default component.exports
import {QForm,QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QForm,QInput,QBtn}, component.options.components || {})
